export const categoryReducer = (state = {}, action) => {
  switch (action.type) {
    case "GET_CATEGORY_REQUEST":
      return {
        ...state,
        loading: true,
        categories: null,
      };
    case "GET_CATEGORY_LIST_SUCCESS":
      return {
        ...state,
        loading: false,
        categories: action.payload,
      };
    case "GET_CATEGORY_LIST_FAILED":
      return {
        ...state,
        loading: false,
        categories: action.payload,
      };

    case "VIEW_CATEGORY_REQUEST":
      return {
        ...state,
        loading: true,
        category: null,
      };
    case "VIEW_CATEGORY_SUCCESS":
      return {
        ...state,
        loading: false,
        category: action.payload,
      };
    case "VIEW_CATEGORY_FAILED":
      return {
        ...state,
        loading: false,
        category: action.payload,
      };

    case "SET_FETCH_TIME":
      return {
        ...state,
        lastFetched: action.payload,
      };
    case "ADD_CATEGORY_REQUEST":
      return {
        ...state,
        loading: true,
        categories: null,
      };
    case "ADD_CATEGORY_SUCCESS": {
      return {
        ...state,
        loading: false,
        categories: action.payload,
      };
    }
    case "ADD_CATEGORY_FAILED": {
      return {
        ...state,
        loading: false,
        categories: action.payload,
      };
    }
    case "GET_SUB_CATEGORIES_LIST_REQUEST": {
      return {
        ...state,
        loading: true,
        subCategories: null,
      };
    }
    case "GET_SUB_CATEGORIES_LIST_SUCCESS": {
      return {
        ...state,
        loading: false,
        subCategories: action.payload,
      };
    }
    case "GET_SUB_CATEGORIES_LIST_FAILED": {
      return {
        ...state,
        loading: false,
        subCategories: action.payload,
      };
    }
    default: {
      return state;
    }
  }
};
